import * as React from 'react';
import { Result } from './result';
import { ISearchResultHitDTO, ISearchResultDTO } from '../../DTO/search';
import { IContentProps } from '../../models/content-props';

interface IProps {
    results: ISearchResultHitDTO[];
    content: IContentProps;
    showUrl: boolean;
    onResultClick: (hitId) => void;
}

export class ResultList extends React.Component<IProps, any> {
    renderResults = ((result, index) =>
        <Result result={result} key={`${result.url} ${result.title} ${index}`} onClick={this.props.onResultClick} content={this.props.content} showUrl = {this.props.showUrl} />
    );

    componentDidMount() {
    }

    render() {
        return (
            <ul className="directory-list no-bullets" aria-live="polite">
                {this.props.results.map(this.renderResults)}
            </ul>
        )
    }
}

